import { accessToken } from '@carvana/core-auth';
import type { AxiosResponse } from 'axios';
import { axios, httpWithAuth } from '~/clients';
import { INVENTORY } from '~/constants/endpoints';
import { InventoryRequest, InventoryResponse } from '~/services/srp/contracts';

export default function fetchLowInventory(
  request: InventoryRequest,
  controller: AbortController
): Promise<AxiosResponse<InventoryResponse>> {
  const isAuthUser = accessToken().isValidToken;
  const client = isAuthUser ? httpWithAuth : axios;

  return client.post<InventoryResponse>(`${INVENTORY}/should`, request, {
    signal: controller.signal
  });
}
